export const API_KEYS_ACTION = {
  // List
  GET_API_KEYS: 'GET_API_KEYS',
  GET_API_KEYS_SUCCESS: 'GET_API_KEYS_SUCCESS',
  GET_API_KEYS_ERROR: 'GET_API_KEYS_ERROR',

  // Create
  CREATE_API_KEY: 'CREATE_API_KEY',
  CREATE_API_KEY_SUCCESS: 'CREATE_API_KEY_SUCCESS',
  CREATE_API_KEY_ERROR: 'CREATE_API_KEY_ERROR',
  CREATE_API_KEY_CLEAN_STATE: 'CREATE_API_KEY_CLEAN_STATE',

  // Update
  UPDATE_API_KEY: 'UPDATE_API_KEY',
  UPDATE_API_KEY_SUCCESS: 'UPDATE_API_KEY_SUCCESS',
  UPDATE_API_KEY_ERROR: 'UPDATE_API_KEY_ERROR',
  UPDATE_API_KEY_CLEAN_STATE: 'UPDATE_API_KEY_CLEAN_STATE',

  // Revoke
  REVOKE_API_KEY: 'REVOKE_API_KEY',
  REVOKE_API_KEY_SUCCESS: 'REVOKE_API_KEY_SUCCESS',
  REVOKE_API_KEY_ERROR: 'REVOKE_API_KEY_ERROR',
  REVOKE_API_KEY_CLEAN_STATE: 'REVOKE_API_KEY_CLEAN_STATE',

  // Delete
  DELETE_API_KEY: 'DELETE_API_KEY',
  DELETE_API_KEY_SUCCESS: 'DELETE_API_KEY_SUCCESS',
  DELETE_API_KEY_ERROR: 'DELETE_API_KEY_ERROR',
  DELETE_API_KEY_CLEAN_STATE: 'DELETE_API_KEY_CLEAN_STATE',

  // Clear created key (after modal close)
  CLEAR_CREATED_KEY: 'CLEAR_CREATED_KEY',
};

// =========================================================================
// List API Keys
export const getApiKeys = (params) => ({
  type: API_KEYS_ACTION.GET_API_KEYS,
  payload: params,
});

export const getApiKeysSuccess = (data) => ({
  type: API_KEYS_ACTION.GET_API_KEYS_SUCCESS,
  payload: data,
});

export const getApiKeysError = ({ message }) => ({
  type: API_KEYS_ACTION.GET_API_KEYS_ERROR,
  payload: message,
});

// =========================================================================
// Create API Key
export const createApiKey = (data) => ({
  type: API_KEYS_ACTION.CREATE_API_KEY,
  payload: data,
});

export const createApiKeySuccess = (data) => ({
  type: API_KEYS_ACTION.CREATE_API_KEY_SUCCESS,
  payload: data,
});

export const createApiKeyError = ({ message }) => ({
  type: API_KEYS_ACTION.CREATE_API_KEY_ERROR,
  payload: message,
});

export const createApiKeyCleanState = () => ({
  type: API_KEYS_ACTION.CREATE_API_KEY_CLEAN_STATE,
});

// =========================================================================
// Update API Key
export const updateApiKey = (data) => ({
  type: API_KEYS_ACTION.UPDATE_API_KEY,
  payload: data,
});

export const updateApiKeySuccess = (data) => ({
  type: API_KEYS_ACTION.UPDATE_API_KEY_SUCCESS,
  payload: data,
});

export const updateApiKeyError = ({ message }) => ({
  type: API_KEYS_ACTION.UPDATE_API_KEY_ERROR,
  payload: message,
});

export const updateApiKeyCleanState = () => ({
  type: API_KEYS_ACTION.UPDATE_API_KEY_CLEAN_STATE,
});

// =========================================================================
// Revoke API Key
export const revokeApiKey = (data) => ({
  type: API_KEYS_ACTION.REVOKE_API_KEY,
  payload: data,
});

export const revokeApiKeySuccess = (data) => ({
  type: API_KEYS_ACTION.REVOKE_API_KEY_SUCCESS,
  payload: data,
});

export const revokeApiKeyError = ({ message }) => ({
  type: API_KEYS_ACTION.REVOKE_API_KEY_ERROR,
  payload: message,
});

export const revokeApiKeyCleanState = () => ({
  type: API_KEYS_ACTION.REVOKE_API_KEY_CLEAN_STATE,
});

// =========================================================================
// Delete API Key
export const deleteApiKey = (data) => ({
  type: API_KEYS_ACTION.DELETE_API_KEY,
  payload: data,
});

export const deleteApiKeySuccess = (data) => ({
  type: API_KEYS_ACTION.DELETE_API_KEY_SUCCESS,
  payload: data,
});

export const deleteApiKeyError = ({ message }) => ({
  type: API_KEYS_ACTION.DELETE_API_KEY_ERROR,
  payload: message,
});

export const deleteApiKeyCleanState = () => ({
  type: API_KEYS_ACTION.DELETE_API_KEY_CLEAN_STATE,
});

// =========================================================================
// Clear created key
export const clearCreatedKey = () => ({
  type: API_KEYS_ACTION.CLEAR_CREATED_KEY,
});
